export default "__VITE_ASSET__BkLWSg0O__"